import React from 'react';
import Proyectos from './Proyectos';
import Capabilities from './Capabilities';
import Tools from './Tools';
import Contact from './Contact';
import Hero from './Hero';

const Home = () => {

    return(
        <div id="#home" style={{ width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
            <Hero />
            <Proyectos />
            <Capabilities />
            <Tools />
            <Contact />
        </div>
    )
}

export default Home;